import React, { useState, useContext, useEffect } from 'react';
import Select from 'antd/lib/select';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAxiosInstance, getAxiosTokenInstance } from '../../utils/axiosInstance';
import moment from 'moment';
import { Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { v4 as uuid4 } from 'uuid';

const { Option } = Select;

function EditTcFinal({ setLoading, data, refetch, onClose , setProfile}) {
	const { collegeId } = useContext(FirebaseContext);

	const semester = ['l Semester', 'll Semester', 'lll Semester', 'lV Semester', 'V Semester', 'Vl Semester', 'Vll Semester', 'Vlll Semester', 'lX Semester', 'X Semester'];
	const Exams = ['Not attended', ...semester];
	const reason = ['Course Completed', 'Discontinued', 'College Transfer', 'Higher Studies'];
	const Catogorys = ['GENERAL', 'OBC', 'OBC (H)', 'OEC', 'ST', 'SC'];
	const [sections, setSections] = useState([]);

	const getDetails = async () => {
		try {
			const instance = getAxiosInstance();
			const { data } = await instance.get('/college/action/getTcSettings', {
				params: { collegeId, tcSettings: 'tcSettings', tcSections: 'tcSections' },
			});
			return data;
		} catch (error) {
			console.error('Error in getDetails:', error);
			throw error;
		}
	};

	const { data: sectionsData, isFetched } = useQuery(['sections', { collegeId }], getDetails, {
		cacheTime: 60 * 30 * 1000,
		refetchOnWindowFocus: false,
	});

	useEffect(() => {
		if (isFetched && sectionsData?.statusCode === 200) {
			if (sectionsData?.tcSettings?.sections) {
				let allFields = sectionsData.tcSettings?.sections
					.filter((x) => x.checked)
					.map((item) => {
						if (item._id) {
							return item;
						} else {
							return { ...item, _id: uuid4() };
						}
					});

				let isAlreadyAdded = ['reasonForLeaving', 'name', 'exam', 'leavingSem', 'leaving', 'shortName', 'dateOfLeaving', 'aprovedOn', 'appliedOn', 'longName', 'category', 'admisionNo', 'regNo', 'dateOfAdmission', 'tcIssueDate', 'dob', 'requestLetter', 'joinedSem', 'tcNumber', 'semesterJoin'];
				allFields = allFields.filter((item) => {
					if (item.checked && item?.keyName) {
						if (isAlreadyAdded.includes(item.keyName)) {
							return false;
						} else {
							isAlreadyAdded.push(item.keyName);
						}
						return true;
					}
				});
				setSections(allFields);
			}
		}
	}, [sectionsData]);

	const [formData, setFormData] = useState({
		classId: data?.classId || '',
		name: data?.name || '',
		category: data?.category || '',
		admisionNo: data?.admisionNo || '',
		regNo: data?.hallTicketNo || '',
		dateOfAdmission: moment(data?.dateOfAdmission).format('YYYY-MM-DD') || '',
		dateOfLeaving: moment(data?.dateOfLeaving).format('YYYY-MM-DD') || '',
		aprovedOn: data?.aprovedOn ? moment(data?.aprovedOn).format('YYYY-MM-DD') : '',
		tcIssueDate: data?.tcIssueDate ? moment(data?.tcIssueDate).format('YYYY-MM-DD') : '',
		appliedOn: moment(data?.appliedOn).format('YYYY-MM-DD') || '',
		dob: moment(data?.dob).format('YYYY-MM-DD') || '',
		exam: data?.exam || '',
		requestLetter: data?.requestLetter || '',
		joinedSem: data?.joinedSem || '',
		reasonForLeaving: data?.reasonForLeaving || '',
		leaving: data?.leaving || '',
		tcNumber: data?.tcNumber || '',
	});

	const handleChange = (field, value) => {
		setFormData((prev) => ({ ...prev, [field]: value }));
	};
	console.log(data);

	const adsUserTc = async () => {
		const instance = await getAxiosTokenInstance();
		await instance.post('/college/transferCertificate/editForTcCcNew', {
			collegeId,
			formData,
			fullName: formData.name,
			dob: formData.dob,
			classId: formData.classId,
			doa: formData.dateOfAdmission,
			userId: data.uid,
			requestLetterId: data?._id,
			admisionNo: formData.admisionNo,
			category: formData.category,
			...(formData.aprovedOn && { aprovedOn: formData.aprovedOn }),
			...(formData.tcNumber && { tcNumber: formData.tcNumber }),
			regNo: formData.regNo,
			joinedSem: formData.joinedSem,
			requestLetter: formData.requestLetter,
			reasonForLeaving: formData.reasonForLeaving,
			tcIssueDate: formData.tcIssueDate,
			exam: formData.exam,
			leaving: formData.leaving,
			appliedOn: formData.appliedOn,
			dol: formData.dateOfLeaving,
		});
		refetch();
		onClose();
		setProfile(null)
	};

	const getClassesList = async ({ queryKey }) => {
		const [_, { collegeId }] = queryKey;
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/classes/getClass', {
			params: { collegeId, needAll: true, classOnly: true },
		});
		return resp?.data;
	};

	const classQuery = useQuery(['classes', { collegeId }], getClassesList);

	return (
		<Main width='60vw' height='100vh'>
			<div className='bg-white p-6 rounded-lg shadow-lg mx-auto relative w-full h-full overflow-y-scroll'>
				<div className='absolute right-0 top-0'>
					<Button type='close' onClick={onClose}>
						close
					</Button>
				</div>
				<h2 className='text-2xl font-semibold mb-6 text-center'>Edit TC</h2>
				<div className='grid grid-cols-2 md:grid-cols-2 gap-4'>
					<div>
						<label className='block mt-4  mb-2 font-medium'>Class Name</label>
						<Select className='w-full' value={formData.classId} onChange={(e) => handleChange('classId', e)}>
							{classQuery?.data?.list?.map((cls) => (
								<Option key={cls.classId} value={cls.classId}>
									{cls.className}
								</Option>
							))}
						</Select>
					</div>

					<div>
						<label className='block mt-4 mb-2 font-medium'>Full Name</label>
						<input className='w-full p-2 border rounded-md' value={formData.name} onChange={(e) => handleChange('name', e.target.value)} />
					</div>

					<div>
						<label className='block mt-4 mb-2 font-medium'>Category</label>
						<Select className='w-full' value={formData.category} onChange={(e) => handleChange('category', e)}>
							{Catogorys.map((cat) => (
								<Option key={cat} value={cat}>
									{cat}
								</Option>
							))}
						</Select>
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Admission No</label>
						<input className='w-full p-2 border rounded-md' value={formData.admisionNo} onChange={(e) => handleChange('admisionNo', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Register No</label>
						<input className='w-full p-2 border rounded-md' value={formData.regNo} onChange={(e) => handleChange('regNo', e.target.value)} />
					</div>

					<div>
						<label className='block mt-4 mb-2 font-medium'>Date of Admission</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.dateOfAdmission} onChange={(e) => handleChange('dateOfAdmission', e.target.value)} />
					</div>

					<div>
						<label className='block mt-4 mb-2 font-medium'>TC Number</label>
						<input className='w-full p-2 border rounded-md' value={formData.tcNumber} onChange={(e) => handleChange('tcNumber', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>TC Approved Date</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.aprovedOn} onChange={(e) => handleChange('aprovedOn', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Issue Date</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.tcIssueDate} onChange={(e) => handleChange('tcIssueDate', e.target.value)} />
					</div>
					<div>
						<label className='block mb-2 mt-4  font-medium'>Reason for Leaving</label>
						<Select className='w-full' value={formData.reasonForLeaving} onChange={(e) => handleChange('reasonForLeaving', e)}>
							{reason.map((res) => (
								<Option key={res} value={res}>
									{res}
								</Option>
							))}
						</Select>
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Date of Leaving</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.dateOfLeaving} onChange={(e) => handleChange('dateOfLeaving', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Date of Birth</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.dob} onChange={(e) => handleChange('dob', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Applied On</label>
						<input type='date' className='w-full p-2 border rounded-md' value={formData.appliedOn} onChange={(e) => handleChange('appliedOn', e.target.value)} />
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Semester Joined</label>
						<Select className='w-full' value={formData.joinedSem} onChange={(e) => handleChange('joinedSem', e)}>
							{semester.map((sem) => (
								<Option key={sem} value={sem}>
									{sem}
								</Option>
							))}
						</Select>
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Semester from Leaving</label>
						<Select className='w-full' value={formData.leaving} onChange={(e) => handleChange('leaving', e)}>
							{semester.map((sem) => (
								<Option key={sem} value={sem}>
									{sem}
								</Option>
							))}
						</Select>
					</div>
					<div>
						<label className='block mt-4 mb-2 font-medium'>Last Exam Attended</label>
						<Select className='w-full' value={formData.exam} onChange={(e) => handleChange('exam', e)}>
							{Exams.map((exam) => (
								<Option key={exam} value={exam}>
									{exam}
								</Option>
							))}
						</Select>
					</div>
					{sections &&
						sections
							?.filter((x) => x.keyName && x.checked && x.type)
							?.map((item, index) => (
								<div key={index}>
									<label className='block text-sm font-medium text-gray-700 mb-2'>{item.title || item.longTitle}</label>
									{item.type === 'array' ? (
										<Select value={formData[item.keyName]} className='w-full' onChange={(val) => setFormData({ ...formData, [item.keyName]: val })}>
											{item.options?.map((option, idx) => (
												<Option key={idx} value={option.value}>
													{option.label}
												</Option>
											))}
										</Select>
									) : item.type === 'date' ? (
										<input type='date' value={formData[item.keyName]} onChange={(e) => setFormData({ ...formData, [item.keyName]: e.target.value })} className='w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500' />
									) : (
										<input type='text' value={formData[item.keyName]} onChange={(e) => setFormData({ ...formData, [item.keyName]: e.target.value })} className='w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500' />
									)}
								</div>
							))}
				</div>
				<label className='block mt-4 mb-2 font-medium'>Request Letter</label>
				<textarea className='w-full p-2 border rounded-md' rows={4} value={formData.requestLetter} onChange={(e) => handleChange('requestLetter', e.target.value)} />

				<div className='mt-6 flex justify-center'>
					<button className='bg-blue-500 text-white py-2 px-6 rounded-md hover:bg-blue-600' onClick={adsUserTc}>
						Submit
					</button>
				</div>
			</div>
		</Main>
	);
}

export default EditTcFinal;
